<template>
  <div>
    <div class="Kanit">
      <div class="text-center mt-8">
        <img height="100px" src="@/assets/logo.png" />
      </div>
      <div class="text-center mt-4">
        <v-icon size="120" color="primary">mdi-check-circle-outline</v-icon>
      </div>
      <div
        class="text-center primary--text font-weight-bold"
        style="font-size: 21px"
      >
        กำหนดรหัสผ่านใหม่ <br />เรียบร้อยแล้ว
      </div>
      <div class="text-center mt-4">
        <v-btn @click="$liff.closeWindow" large color="primary">ปิด</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from "../../components/CustomInput.vue";
import axios from "axios";
export default {
  components: { CustomInput },
};
</script>

<style lang="scss" scoped>
</style>